module.exports = __webpack_public_path__ + "img/x12.e864927b.jpg";